import React from 'react';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import PropTypes from 'prop-types';
import { PAYMENT_GATEWAY } from '@/modules/payments/contants/prepaid';

export const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
// Expects data: [{ paymentMethods, amount }]
const PieChartPagosPorMetodo = ({ data = [] }) => {
  const hasData = data?.some(item => item.count > 0);
  
  const chartData = hasData ?
    data
      ?.sort((a, b) => a.paymentMethods.localeCompare(b.paymentMethods))
      ?.map(item => ({
        name: PAYMENT_GATEWAY[item.paymentMethods] || item.paymentMethods,
        value: item.count,
      })) :
    [{ name: 'Sin datos', value: 1 }];
  
  return (
    <ResponsiveContainer width="100%" height={350}>
      <PieChart>
        <Pie
          data={chartData}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          outerRadius={100}
          label={
            hasData
              ? ({ name, percent }) => `${name}: ${(percent * 100).toFixed(1)}%`
              : false
          }
          labelLine={false}
          tooltipAccessor="value"
        >
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={hasData ? COLORS[index % COLORS.length] : '#E5E7EB'} />
          ))}
        </Pie>
        <Tooltip formatter={(value) => value.toLocaleString()} />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};

PieChartPagosPorMetodo.propTypes = {
  data: PropTypes.array,
};


export default PieChartPagosPorMetodo;

